import { useContext, useEffect, useState } from 'react'
import { FollowUpAgentsContext } from '../../../context/FollowUpAgentsContext';
import { useTranslation } from 'react-i18next';

export default function AgentProfileCard({ data }) {

  const { t } = useTranslation();

  const { agentSelected, setAgentSelected } = useContext(FollowUpAgentsContext)

  const [isSelected, setIsSelected] = useState(false);

  const handleToggleSelection = () => {

    if (agentSelected?.agent_id !== data.agent_id) {
      setAgentSelected(data)
    }
  }

  useEffect(() => {
    setIsSelected(agentSelected?.agent_id === data.agent_id)

    // if(agentSelected?.agent_id === data.agent_id) {
    //   setIsSelected(true)
    // } else {
    //   setIsSelected(false)
    // }
  }, [agentSelected])


  const select = (isSelected) ? 'selected-card' : 'tracking-ticket'
  return (
    <div className={`card shadow-none rounded-0 border-0 border-bottom rounded-0 ${select}`} onClick={handleToggleSelection}>

      <div className='p-3 d-flex'>
        <div className="avatar avatar avatar-circle">
          <span className="avatar avatar-info avatar-circle">
            <span className="avatar-initials text-white-dark">{data.username[0]}</span>
            {data.status.toUpperCase() === 'ONLINE' ? <span className="avatar-status avatar-status-primary"></span> : null}
          </span>
        </div>
        <div className="flex-grow-1 px-2 no-hover">
          <h5 className="mbottom-6">{data.username}</h5>
          <p className='m-0 p-0 lh-11'>{data.total_messages} {t('follow-up.agents.profile.assigned-tickets')}</p>
          <p className='mt-2 mbottom-6'>{data.time_in_sesion} {t('follow-up.agents.profile.in-session-time')}</p>

          {data.sub_account ? (
            <span className="badge bg-secondary">{data.sub_account}</span>
          ) : (
            <span className="badge bg-danger badge-sm font-10" >{t('follow-up.agents.profile.no-subaccount')}</span>
          )}
        </div>
        <div>
          <span className="col badge bg-info ms-2 me-2">{data.status_table}</span>
        </div>
      </div>
      {/* <div className="row g-0 p-3">
        <div className="col-lg-3">
          <div className='card-body p-0 d-flex justify-content-center'>
            <span className="avatar avatar-primary avatar-circle">
              <span className="avatar-initials">{data.username[0]}</span>
            </span>
          </div>
        </div>
        <div className="col-md-6">
          <div className="card-body p-0">
            <h5 className="card-title" style={{ marginBottom: '6px' }}>{data.username}</h5>
            <p className='m-0 p-0'>{123} Tickets asignados</p>
            <p className='' style={{ marginTop: '8px', marginBottom: '6px' }}>{data.time_in_sesion} horas de sesión</p>

            {data.sub_account ? (
              <span className="badge bg-secondary">{data.sub_account}</span>
            ) : (
              <span className="badge bg-danger badge-sm" style={{ fontSize: '10px' }}>Agente sin Subcuenta</span>
            )}
          </div>
        </div>
        <div className="col-md-3">
          <div className="card-body p-0 text-end">
            <span className="col badge bg-info ms-2 me-2">{data.status}</span>
          </div>
        </div>
      </div> */}
    </div>

  )
}
